import { useTaxCompliance } from "@/features/auth";

import { usePaymentAction } from "../hooks/use-payment-action";

import type { PaymentKind } from "../types";

type ActionablePaymentKind = Extract<PaymentKind, "micropayment" | "stipend">;

export interface ActionableState {
  isTaxCompliant: boolean;
  isTaxFormLoading: boolean;
  isActionPending: boolean;
  onAccept: () => void;
  onRejectConfirm: (reason: string) => void;
}

export const useActionableState = (
  paymentKind: ActionablePaymentKind,
  id: string
): ActionableState => {
  const { isTaxCompliant, isLoading } = useTaxCompliance();

  const { onAccept, onReject, isPending } = usePaymentAction({
    paymentKind,
    id,
  });

  return {
    isTaxCompliant: isTaxCompliant === true,
    isTaxFormLoading: isLoading,
    isActionPending: isPending,
    onAccept,
    onRejectConfirm: onReject,
  };
};
